define(function() {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		parse: function(response) {
			return response;
		}
	});
});
